import { render, staticRenderFns } from "./NavigationAccountExpandCollapse.vue?vue&type=template&id=2d33cadc&scoped=true&"
import script from "./NavigationAccountExpandCollapse.vue?vue&type=script&lang=js&"
export * from "./NavigationAccountExpandCollapse.vue?vue&type=script&lang=js&"
import style0 from "./NavigationAccountExpandCollapse.vue?vue&type=style&index=0&id=2d33cadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33cadc",
  null
  
)

export default component.exports